import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskManagerDetailComponent } from './task-manager-detail.component';
import { FilterAssignmentsPipe } from './filter-assignments.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [TaskManagerDetailComponent,
    FilterAssignmentsPipe
  ],
  exports: [TaskManagerDetailComponent]
})
export class TaskManagerDetailModule { }